import { OutboundTripDestinationCompanyDto } from 'dtos/outboundTrips'
import * as yup from 'yup'

export const OutboundTripDestinationCompanyDtoValidator = yup.object<OutboundTripDestinationCompanyDto>({
  companyGuid: yup.string().required('Buyer or Exporter Company is required.')
})
